
import React from "react";
import { SwapRequest } from "@/services/myReagents";
import SwapRequestCard from "./SwapRequestCard";

interface PendingRequestsSectionProps {
  requests: SwapRequest[];
  isSentByUser?: boolean;
  onApprove?: (request: SwapRequest) => void;
  onReject?: (request: SwapRequest) => void;
  onEdit?: (request: SwapRequest) => void;
  onDelete?: (request: SwapRequest) => void;
}

const PendingRequestsSection: React.FC<PendingRequestsSectionProps> = ({
  requests,
  isSentByUser = false,
  onApprove,
  onReject,
  onEdit,
  onDelete
}) => {
  if (requests.length === 0) return null;

  return (
    <div>
      <h3 className="text-lg font-medium mb-4">
        Pending {isSentByUser ? "Sent" : ""} Requests ({requests.length})
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {requests.map((request) => (
          <SwapRequestCard
            key={request.id}
            request={request}
            isPending={true}
            isSentByUser={isSentByUser}
            onApprove={onApprove}
            onReject={onReject}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default PendingRequestsSection;
